import { Button, Flex, Icon, useDisclosure } from '@chakra-ui/react';
import type { ComponentType, ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPlus } from 'react-icons/fa';

interface NavbarProps {
  type: string;
  addModalAs: ComponentType | ElementType;
}

const Navbar = ({ type, addModalAs }: NavbarProps) => {
  const addModal = useDisclosure();
  const { t } = useTranslation();

  const AddModal = addModalAs;
  return (
    <>
      <Flex py={8} gap={4}>
        {/* TODO: Complete search functionality */}
        {/* <InputGroup w={{ base: "100%", md: "auto" }}>
          <InputLeftElement pointerEvents="none">
            <Icon as={FaSearch} color="ui.dim" />
          </InputLeftElement>
          <Input
            type="text"
            placeholder="Search"
            fontSize={{ base: "sm", md: "inherit" }}
            borderRadius="8px"
          />
        </InputGroup> */}
        <Button gap={1} fontSize={{ base: 'sm', md: 'inherit' }} onClick={addModal.onOpen}>
          <Icon as={FaPlus} /> {t(`${type.toLowerCase()}.drawer.add.title`)}
        </Button>
        <AddModal isOpen={addModal.open} onClose={addModal.onClose} />
      </Flex>
    </>
  );
};

export default Navbar;
